<template>
  <maintenance-view v-if="isMaintenanceActive('casesAndClaims')" />
    <div v-else class="app-view-container-wrapper">
        <div class="app-view-container">
            <el-row>
                <el-col class="app-view-title">
                    <span>{{ $t('casesAndClaims.title') }}</span>
                </el-col>
            </el-row>

            <el-row>
                <el-col>
                    <!-- Filtros Compactos para Cliente -->
                    <search-filter ref="searchFilterList" />
                </el-col>
            </el-row>

            <el-row class="search-summary-container bg-white">
                <el-col>
                    <el-row class="default-section-header">
                        <el-col :span="7" class="default-section-title">
                            <span>{{ $t('casesAndClaims.title') }}</span>
                            <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
                            </el-tooltip>
                        </el-col>
                        <!-- el-col :span="10"  class="default-section-title totals-section">
                            <el-row class="default-section-header"></el-row>
                        </el-col -->
                        <el-col :span="7" class="default-section-actions text-align-end" v-if="canAddCaseAndClaim">
                            <span id="manage-shipment-more-actions-section">
                                <el-button
                                    id="add-case-client"
                                    class="button-action-default"
                                    size="mini"
                                    type="success"
                                    plain
                                    @click="openShipmentSearch"
                                >
                                {{ $t('casesAndClaims.new') || 'New' }}
                                </el-button>
                            </span>
                        </el-col>
                    </el-row>
                    <el-row class="search-summary">
                        <el-col>
                            <search-summary ref="searchSummary" />
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>

            <!-- Modal HU-008 Paso 1: Busqueda de Shipment -->
            <shipment-search-modal ref="shipmentSearchModal" @shipment-selected="handleShipmentSelected" :user-account-id="userAccountId" />

            <!-- Modal HU-008 Paso 2: Creacion de Caso -->
            <client-add-case-modal ref="clientAddCaseModal" @saved="handleRefresh" />

        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import appConfig from '@/config/app-config';
import MaintenanceView from '@/views/maintenance/index';
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';
import ShipmentSearchModal from './components/ShipmentSearchModal';
import ClientAddCaseModal from './components/ClientAddCaseModal';


export default {
  name: 'ClientCasesAndClaims',
  components: {
    MaintenanceView,
    SearchFilter,
    SearchSummary,
    ShipmentSearchModal,
    ClientAddCaseModal
  },
  computed: {
    ...mapState('clientCasesAndClaims', ['currentAccountId']),
    canAddCaseAndClaim() {
      // const permissions = this.$store.state.user.permissions || [];
      // return permissions.includes('getClaimData:Shipments');
      return true; // TODO: remove after permissions are implemented
    },
    userAccountId() {
      return this.currentAccountId || null;
    }
  },
  mounted() {
    // console.log('Logged in User:', this.$store.state.user);
    // console.log('User Groups:', this.$store.state.user.groups);
    // console.log('User AccountID:', this.$store.state.user.accountId);
    this.handleRefresh();
  },
  methods: {
    isMaintenanceActive(menuKey) {
      if (!menuKey || !appConfig.maintenanceConfig || !appConfig.maintenanceConfig[menuKey]) {
        return false;
      }

      const config = appConfig.maintenanceConfig[menuKey];
      const now = new Date();
      const start = new Date(config.start);
      const end = new Date(config.end);

      return now >= start && now <= end;
    },
    handleRefresh() {
      if (this.$refs.searchFilterList && this.$refs.searchFilterList.handleSearch) {
        this.$refs.searchFilterList.handleSearch();
      }
    },
    openShipmentSearch() {
      this.$refs.shipmentSearchModal.open();
    },
    handleShipmentSelected(shipment) {
      this.$refs.clientAddCaseModal.open(shipment);
    },
  },
};
</script>
